var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"youtubes"},[(_vm.error)?_c('div',{staticClass:"m-2"},[_c('h1',[_vm._v("NO SE HA PODIDO REPRODUCIR EL VÍDEO")]),_c('i',{staticClass:"fa fa-bug fa-10x"})]):_vm._e(),(!_vm.error)?_c('video',{ref:"videoPlayer",class:'video-js ',attrs:{"width":"500","height":"500"}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }